import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { Container } from "./container";
import React, { useState } from "react";
import { CardList } from "./blocks/card-list";
import { graphql } from "gatsby";

export const HomeSection: React.FC<{
  title?: string | null;
  anchorTag?: string | null;
  otherTitles?: { name?: string | null; anchorTag?: string | null }[] | null;
  subLinks?: Link[] | null;
  mainLink?: Link | null;
  columns?: number;
  textBlock?: {
    readonly data: {
      readonly text_block: string;
    } | null;
  } | null;
  first?: boolean;
}> = ({
  title,
  anchorTag,
  otherTitles,
  textBlock,
  subLinks,
  mainLink,
  columns = 4,
  first,
  ...props
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <div
      className={`relative -mt-12  ${first ? "pt-20" : "pt-32"}`}
      id={anchorTag || undefined}
      {...props}
    >
      <li
        className={`
              z-10
              mb-8
              inline-flex
              h-12
              cursor-pointer
              items-center
              rounded-r-2xl
              border
              border-l-0
              border-beige
              bg-white
              pl-6
              pr-3
              text-lg
              font-bold
              transition-all
              duration-1000
              lg:h-16
              lg:px-6
              lg:text-2xl
            `}
        onClick={() => setIsMenuOpen((open) => !open)}
      >
        {title}
        {isMenuOpen && (
          <ChevronUpIcon className="relative top-1 ml-2 w-6 text-beige lg:w-8" />
        )}
        {!isMenuOpen && (
          <ChevronDownIcon className="relative top-1 ml-2 w-6 text-beige lg:w-8" />
        )}
      </li>
      {isMenuOpen && (
        <ul
          className={`
            absolute
            left-0
            ${first ? "top-32 lg:top-36" : "top-44 lg:top-48"}
            -z-1
            mt-[-1px]
            flex
            flex-col
            items-start
            transition-all
            duration-1000
          `}
        >
          {otherTitles &&
            otherTitles.map(({ anchorTag, name }, i) => {
              return (
                <li
                  key={`other-title-${i}-${anchorTag}`}
                  className={`
                  z-10
                  mb-[-1px]
                  flex
                  h-12
                  items-center
                  rounded-r-2xl
                  border
                  border-l-0
                  border-beige
                  bg-white
                  px-6
                  text-lg
                  font-bold
                  transition-all
                  duration-1000
                  lg:h-16
                  lg:text-2xl
                `}
                >
                  <a
                    href={`/#${anchorTag}`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {name}
                  </a>
                </li>
              );
            })}
        </ul>
      )}
      <Container>
        {subLinks && (
          <CardList
            textBlock={textBlock}
            mainItem={mainLink}
            items={subLinks}
            showDividerAndTitle={false}
          />
        )}
      </Container>
    </div>
  );
};

export const query = graphql`
  fragment HomeSection on STRAPI__COMPONENT_CONTENT_BLOCKS_HOME_SECTION {
    id
    main_category {
      id
      name
      slug
    }
    main_link {
      ...Link
    }
    sub_links {
      ...Link
    }
    text_block {
      data {
        text_block
      }
    }
  }
`;
